import { render, staticRenderFns } from "./BagLabelCDialog.vue?vue&type=template&id=11ca8ff0&scoped=true"
import script from "./BagLabelCDialog.vue?vue&type=script&lang=js"
export * from "./BagLabelCDialog.vue?vue&type=script&lang=js"
import style0 from "./BagLabelCDialog.vue?vue&type=style&index=0&id=11ca8ff0&prod&scoped=true&lang=css"
import style1 from "./BagLabelCDialog.vue?vue&type=style&index=1&id=11ca8ff0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ca8ff0",
  null
  
)

export default component.exports